import React from 'react';
import { Zap, ArrowRight, Shield } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * BlogCTA — Glassmorphism lead gen widget
 * Inséré au milieu et à la fin de chaque article.
 * Déclenche le DiagnosticWizard via onOpenWizard().
 */
export default function BlogCTA({ onOpenWizard, variant = 'default' }) {
  const isCompact = variant === 'compact';

  return (
    <div
      className={`relative my-10 rounded-2xl overflow-hidden border border-primary/25
        bg-gradient-to-br from-primary/10 via-card/60 to-secondary/10
        backdrop-blur-md shadow-[0_0_40px_hsl(280_85%_58%/0.12)]
        ${isCompact ? 'p-6' : 'p-8 md:p-10'}`}
    >
      {/* Decorative glow orbs */}
      <div className="pointer-events-none absolute -top-10 -left-10 w-40 h-40 rounded-full bg-primary/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-secondary/15 blur-3xl" />

      <div className={`relative flex flex-col ${isCompact ? 'gap-4' : 'gap-6 md:flex-row md:items-center md:gap-8'}`}>

        {/* Left: Icon + Text */}
        <div className="flex-1 space-y-3">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-primary/20 border border-primary/30">
              <Shield className="w-4.5 h-4.5 text-primary" />
            </span>
            <span className="text-xs font-semibold text-primary tracking-widest uppercase">
              Diagnostic gratuit
            </span>
          </div>

          <h3 className={`font-bold text-foreground leading-tight ${isCompact ? 'text-lg' : 'text-xl md:text-2xl'}`}>
            Évaluez la complexité de votre migration Auth0{' '}
            <span className="text-gradient-purple">en 3 minutes</span>
          </h3>

          {!isCompact && (
            <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
              Notre wizard analyse votre infrastructure actuelle et génère un{' '}
              <strong className="text-foreground">rapport PDF personnalisé de 7 pages</strong> — score de maturité IAM, matrice des risques et feuille de route Auth0.
            </p>
          )}

          {/* Trust signals */}
          <div className="flex flex-wrap gap-3 pt-1">
            {['Gratuit', '3 min', 'PDF inclus', 'Sans engagement'].map(label => (
              <span
                key={label}
                className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-primary/70" />
                {label}
              </span>
            ))}
          </div>
        </div>

        {/* Right: CTA Button */}
        <div className="flex-shrink-0">
          <Button
            onClick={onOpenWizard}
            size={isCompact ? 'default' : 'lg'}
            className="w-full md:w-auto bg-primary hover:bg-primary/90 text-primary-foreground glow-purple group"
          >
            <Zap className="w-4 h-4 mr-2 group-hover:animate-pulse" />
            Lancer le diagnostic
            <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
          </Button>
          {!isCompact && (
            <p className="text-xs text-muted-foreground text-center mt-2">
              Rapport téléchargeable immédiatement
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
